import { DashboardTranslationType } from "../../features/dashboard.types";

export const dashboard: DashboardTranslationType = {
  dashboard: {
    newStory: "Neue Geschichte",
    ongoingStories: "Laufende Geschichten",
    completedStories: "Abgeschlossene Geschichten",
    publicStories: "Öffentliche Geschichten",
    loadingStory: "Geschichte wird geladen",
    pleaseWait: "Bitte warten Sie, während wir Ihre Geschichte laden",
    newCharacter: "Neuer Charakter",
    characterCard: {
      personality: "Persönlichkeit",
      strengths: "Stärken",
      weaknesses: "Schwächen",
      skills: "Fähigkeiten"
    },
    search: {
      placeholder: "Geschichten nach Titel durchsuchen...",
      characters: "Charaktere durchsuchen..."
    },
    filters: {
      title: "Filter",
      reset: "Zurücksetzen",
      apply: "Anwenden",
      sortBy: "Sortieren nach",
      filterByRole: "Nach Rolle filtern",
      name: "Name",
      role: "Rolle",
      dateCreated: "Erstellungsdatum",
      rating: "Bewertung", // Added missing key
      allRoles: "Alle Rollen",
      roles: {
        all: "Alle Rollen",
        protagonist: "Hauptfigur",
        antagonist: "Antagonist",
        deuteragonist: "Nebenfigur",
        mentor: "Mentor",
        comic_relief: "Comic Relief",
        mysterious: "Mysteriöse Figur",
        love_interest: "Liebesinteresse",
        anti_hero: "Antiheld",
        sidekick: "Gefährte",
        shapeshifter: "Gestaltwandler",
        guardian: "Wächter",
        catalyst: "Katalysator",
        character: "Charakter",
        supporting: "Unterstützender Charakter"
      }
    },
    navigation: {
      stories: "Geschichten",
      characters: "Charaktere",
      publicStories: "Öffentliche Geschichten",
      stats: "Statistiken",
      more: "Mehr"
    },
    loadingCharacters: "Charaktere werden geladen...",
    noCharactersFound: "Keine Charaktere gefunden",
    createCharacter: {
      new: "Neuen Charakter",
      title: "Neuen Charakter Erstellen",
      editTitle: "Charakter Bearbeiten",
      basicDetails: "Grundlegende Details",
      characteristics: "Eigenschaften",
      avatarDetails: "Erscheinungsbild",
      personalityTraits: "Persönlichkeitsmerkmale",
      form: {
        name: "Name",
        namePlaceholder: "Charakternamen eingeben",
        description: "Beschreibung",
        descriptionPlaceholder: "Charakterbeschreibung eingeben",
        role: "Rolle",
        selectRole: "Charakterrolle auswählen",
        personality: "Persönlichkeit",
        personalityTraits: "Persönlichkeitsmerkmale",
        personalityPlaceholder: "Geben Sie Persönlichkeitsmerkmale ein",
        strengths: "Stärken",
        strengthsPlaceholder: "Stärken hinzufügen",
        weaknesses: "Schwächen",
        weaknessesPlaceholder: "Schwächen hinzufügen",
        skills: "Fähigkeiten",
        skillsPlaceholder: "Fähigkeiten hinzufügen",
        addTrait: "Merkmal hinzufügen",
        addStrength: "Stärke hinzufügen",
        addWeakness: "Schwäche hinzufügen",
        addSkill: "Fähigkeit hinzufügen",
        "add.Personality.Traits": "Persönlichkeitsmerkmale hinzufügen",
        "add.Strengths": "Stärken hinzufügen",
        "add.Weaknesses": "Schwächen hinzufügen",
        "add.Skills": "Fähigkeiten hinzufügen",
        unnamedCharacter: "Unbenannter Charakter",
        cancel: "Abbrechen",
        create: "Charakter Erstellen",
        update: "Charakter Aktualisieren"
      },
      buttons: {
        create: "Charakter Erstellen",
        update: "Charakter Aktualisieren",
        cancel: "Abbrechen",
        updating: "Aktualisieren...",
        creating: "Erstellen...",
      },
      avatarGenerator: {
        genderLabel: "Erscheinungstyp",
        genderPlaceholder: "Erscheinungstyp auswählen",
        ageLabel: "Altersgruppe",
        agePlaceholder: "Altersgruppe auswählen",
        hairLabel: "Haarbeschreibung",
        hairPlaceholder: "z.B., Lange schwarze Locken",
        eyeLabel: "Augenfarbe",
        eyePlaceholder: "z.B., Tiefblau",
        clothingLabel: "Kleidungsstil",
        clothingPlaceholder: "z.B., Mittelalterliche Rüstung",
        expressionLabel: "Gesichtsausdruck",
        expressionPlaceholder: "z.B., Selbstbewusstes Lächeln",
        generateButton: "Avatar Generieren",
        generating: "Generierung läuft...",
        previewLabel: "Generierter Avatar",
        selectTitle: "Avatar Auswählen",
        selectDescription: "Wählen Sie einen der generierten Avatare für Ihren Charakter.",
        partialSuccess: "Einige Bilder konnten nicht geladen werden",
        someImagesFailed: "Einige Bilder konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
        selectPreferred: "Wählen Sie Ihren bevorzugten Avatar",
        genderOptions: {
          male: "Mensch - Männlich",
          female: "Mensch - Weiblich",
          // New animal options
          cat: "Tier - Katze",
          dog: "Tier - Hund",
          wolf: "Tier - Wolf",
          fox: "Tier - Fuchs",
          rabbit: "Tier - Hase",
          bird: "Tier - Vogel",
          reptile: "Tier - Reptil",
          // Existing fantasy options
          elf: "Fantasy - Elf",
          dwarf: "Fantasy - Zwerg",
          orc: "Fantasy - Ork",
          vampire: "Fantasy - Vampir",
          werewolf: "Fantasy - Werwolf",
          fairy: "Fantasy - Fee",
          angelic: "Fantasy - Engelsgestalt",
          demonic: "Fantasy - Dämonisch",
          dragonborn: "Fantasy - Drachengeborener",
          centaur: "Fantasy - Zentaur",
          mermaid: "Fantasy - Meerperson",
          humanoid_alien: "Sci-Fi - Humanoider Alien",
          insectoid_alien: "Sci-Fi - Insektoider Alien",
          reptilian_alien: "Sci-Fi - Reptiloider Alien",
          cyborg: "Sci-Fi - Roboter/Cyborg",
          energy_being: "Sci-Fi - Energiewesen",
          tentacled: "Sci-Fi - Tentakelwesen",
          cat_person: "Tier - Katzenwesen",
          dog_person: "Tier - Hundewesen",
          wolf_person: "Tier - Wolfswesen",
          fox_person: "Tier - Fuchswesen",
          rabbit_person: "Tier - Hasenwesen",
          bird_person: "Tier - Vogelwesen",
          reptile_person: "Tier - Reptilienwesen",
          treant: "Mystisch - Wandelnder Baum",
          flower: "Mystisch - Bewusste Blume",
          vine: "Mystisch - Lebende Ranke",
          mushroom: "Mystisch - Sprechender Pilz",
          vegetable: "Mystisch - Animierte Pflanze",
          golem: "Mystisch - Golem",
          ghost: "Mystisch - Geist/Seele",
          shapeshifter: "Mystisch - Gestaltwandler"
        },
        ageOptions: {
          child: "Kind",
          teen: "Jugendlicher",
          adult: "Erwachsener",
          elderly: "Senior"
        },
        success: {
          title: "Avatar Generiert",
          description: "Der Avatar Ihres Charakters wurde erfolgreich erstellt."
        },
        error: {
          title: "Generierung Fehlgeschlagen",
          description: "Avatar konnte nicht generiert werden. Bitte versuchen Sie es erneut."
        },
        upload: {
          button: "Avatar hochladen",
          uploading: "Wird hochgeladen...",
          success: {
            title: "Avatar hochgeladen",
            description: "Ihr Avatar wurde erfolgreich hochgeladen"
          },
          error: {
            title: "Hochladen fehlgeschlagen",
            fileTooLarge: "Avatar-Bild muss kleiner als 5MB sein",
            invalidType: "Bitte laden Sie eine Bilddatei hoch",
            failed: "Fehler beim Hochladen des Avatar-Bildes"
          },
          loading: "Bild wird geladen..."
        }
      },
      messages: {
        successCreated: {
          title: "Charakter erstellt",
          description: "Ihr Charakter wurde erfolgreich erstellt.",
        },
        successUpdated: {
          title: "Charakter aktualisiert",
          description: "Der Charakter wurde erfolgreich aktualisiert.",
        },
        errorLoad: {
          title: "Fehler",
          description: "Fehler beim Laden des Charakters. Bitte versuchen Sie es erneut.",
        },
        errorSave: {
          title: "Fehler",
          description: "Fehler beim Speichern des Charakters. Bitte versuchen Sie es erneut.",
        },
        validation: {
          characterName: {
            title: "Ungültiger Name",
            description: "Der Name des Charakters ist erforderlich.",
          },
        },
      },
    },
    characterManagement: {
      delete: {
        title: "Charakter löschen",
        confirmMessage: "Sind Sie sicher, dass Sie diesen Charakter löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
        cancel: "Abbrechen",
        delete: "Löschen",
        deleting: "Wird gelöscht...",
        success: {
          title: "Charakter gelöscht",
          description: "Der Charakter wurde erfolgreich gelöscht"
        },
        error: {
          title: "Fehler",
          description: "Fehler beim Löschen des Charakters"
        }
      },
      visibility: {
        setPrivate: "Charakter auf privat gesetzt",
        setPublic: "Charakter auf öffentlich gesetzt",
        nowPrivate: "Der Charakter ist jetzt privat",
        nowPublic: "Der Charakter ist jetzt für alle sichtbar",
        error: "Fehler",
        updateFailed: "Aktualisierung der Sichtbarkeit des Charakters fehlgeschlagen"
      },
      rating: {
        submitted: "Bewertung abgesendet",
        thankYou: "Vielen Dank für die Bewertung dieses Charakters!",
        error: "Fehler",
        failed: "Fehler beim Absenden der Bewertung"
      }
    },
    characterTabs: {
      myCharacters: "Meine Charaktere",
      publicCharacters: "Öffentliche Charaktere"
    },
    suggestions: {
      personalities: {
        adaptable: "Anpassungsfähig",
        ambitious: "Ambitioniert",
        brave: "Mutig",
        charismatic: "Charismatisch",
        compassionate: "Mitfühlend",
        confident: "Selbstbewusst",
        creative: "Kreativ",
        determined: "Entschlossen",
        diplomatic: "Diplomatisch",
        empathetic: "Empathisch",
        honorable: "Ehrenhaft",
        humble: "Bescheiden",
        humorous: "Humorvoll",
        innovative: "Innovativ",
        loyal: "Loyal",
        optimistic: "Optimistisch",
        patient: "Geduldig",
        resilient: "Widerstandsfähig",
        wise: "Weise",
        analytical: "Analytisch",
        cautious: "Vorsichtig",
        eccentric: "Exzentrisch",
        mysterious: "Geheimnisvoll",
        pragmatic: "Pragmatisch",
        reserved: "Zurückhaltend",
        stoic: "Stoisch",
        arrogant: "Arrogant",
        cynical: "Zynisch",
        greedy: "Gierig",
        hot_tempered: "Jähzornig",
        impulsive: "Impulsiv",
        manipulative: "Manipulativ",
        obsessive: "Besessen",
        paranoid: "Paranoid",
        prideful: "Stolz",
        reckless: "Leichtsinnig",
        ruthless: "Rücksichtslos",
        vengeful: "Rachsüchtig"
      },
      skills: {
        leadership: "Führung",
        negotiation: "Verhandlung",
        perception: "Wahrnehmung",
        persuasion: "Überzeugung",
        investigation: "Untersuchung",
        survival: "Überleben",
        deception: "Täuschung",
        intimidation: "Einschüchterung",
        performance: "Darstellung",
        medicine: "Medizin",
        sword_fighting: "Schwertkampf",
        archery: "Bogenschießen",
        martial_arts: "Kampfkünste",
        stealth: "Schleichen",
        acrobatics: "Akrobatik",
        marksmanship: "Treffsicherheit",
        hand_to_hand: "Nahkampf",
        tactical: "Taktisch",
        magic: "Magie",
        elemental_control: "Elementarkontrolle",
        healing: "Heilung",
        necromancy: "Nekromantie",
        prophecy: "Prophezeiung",
        shapeshifting: "Gestaltwandlung",
        telepathy: "Telepathie",
        telekinesis: "Telekinese",
        alchemy: "Alchemie",
        summoning: "Beschwörung",
        hacking: "Hacking",
        piloting: "Pilotieren",
        robotics: "Robotik",
        cybernetics: "Kybernetik",
        nanotech: "Nanotechnologie",
        quantum_physics: "Quantenphysik",
        ai_programming: "KI-Programmierung",
        bioengineering: "Bioengineering",
        time_manipulation: "Zeitmanipulation",
        energy_weapons: "Energie-Waffen",
        crafting: "Handwerk",
        cooking: "Kochen",
        music: "Musik",
        art: "Kunst",
        writing: "Schreiben",
        forgery: "Fälschung",
        invention: "Erfindung",
        linguistics: "Linguistik",
        history: "Geschichte",
        science: "Wissenschaft",
        psychology: "Psychologie",
        archaeology: "Archäologie",
        cryptography: "Kryptographie",
        strategy: "Strategie",
        mythology: "Mythologie",
        economics: "Wirtschaft"
      }
    },
    deleteStory: {
      confirmTitle: "Geschichte löschen",
      confirmMessage: "Sind Sie sicher, dass Sie diese Geschichte löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
      success: "Geschichte gelöscht",
      successMessage: "Die Geschichte wurde erfolgreich gelöscht.",
      error: "Fehler",
      errorMessage: "Fehler beim Löschen der Geschichte. Bitte versuchen Sie es erneut."
    },
    upgradeForMore: "Upgrade für mehr",
    storiesRemaining: "Geschichten heute übrig",
    storiesAvailable: "Geschichten heute verfügbar",
    by: "von",
    anonymous: "Anonym",
    completed: "Abgeschlossen",
    public: "Öffentlich",
    makePublic: "Öffentlich machen",
    makePrivate: "Privat machen",
    upgradeToMakePublic: "Upgrade für öffentliche Geschichten",
    error: "Fehler",
    rating: {
      submitted: "Bewertung abgesendet",
      thankYou: "Vielen Dank für die Bewertung dieser Geschichte!",
      failed: "Bewertung konnte nicht gesendet werden"
    },
    upgrade: {
      required: "Upgrade Erforderlich",
      description: "Upgraden Sie Ihr Konto, um Geschichten öffentlich zu machen und mit anderen zu teilen.",
      shareStories: "Teilen Sie Ihre Geschichten mit einem Premium-Abonnement",
      now: "Jetzt Upgraden"
    },
    startedTime: "Gestartet {{time}}",
    storyVisibility: {
      madePublic: "Geschichte öffentlich gemacht",
      madePrivate: "Geschichte privat gemacht", 
      publicDescription: "Andere können diese Geschichte jetzt sehen",
      privateDescription: "Diese Geschichte ist jetzt privat"
    },
    stats: {
      tabs: {
        badges: "Abzeichen",
        stories: "Geschichten",
        characters: "Charaktere",
        engagement: "Beteiligung"
      },
      badges: {
        loading: "Abzeichen werden geladen...",
        earned: "Erhalten:",
        error: {
          title: "Fehler",
          loadBadges: "Fehler beim Laden der Abzeichen",
          loadProgress: "Fehler beim Laden des Abzeichenfortschritts"
        },
        items: {
          "06491397-1302-45c5-85f7-31e5c46ed3d9": {
            name: "Produktiver Autor",
            description: "Schließen Sie 100 Geschichten ab",
            category: "Schreiben"
          },
          "0b4b084c-4344-4ad0-9b0c-99b03e6fccc8": {
            name: "Historischer Romanautor",
            description: "Schließen Sie 3 historische Fiktion-Geschichten ab",
            category: "Genres"
          },
          "1a86f197-46e4-4158-bc93-461d83d52b5e": {
            name: "Ausdauernder Schriftsteller",
            description: "Schreiben Sie an 30+ aufeinanderfolgenden Tagen Antworten",
            category: "Schreiben"
          },
          "21a94bad-5405-4d27-ab85-2d4049d708aa": {
            name: "Mysterium-Löser",
            description: "Schließen Sie 10 Mystery-Geschichten ab",
            category: "Genres"
          },
          "22e8ee37-d737-41ee-be9b-c3aa2e6d6898": {
            name: "Dialog-Architekt",
            description: "Tragen Sie 10.000 Wörter Dialog durch Interaktionen bei",
            category: "Schreiben"
          },
          "258f5de2-f824-4bf1-adaf-e06df8cb27d0": {
            name: "Topkritiker",
            description: "Bewerten Sie 20 Charaktere",
            category: "Gemeinschaft"
          },
          "2fb0b566-d564-4b54-8f74-b39130099161": {
            name: "Beziehungsaufbauer",
            description: "Erstellen Sie Beziehungen zwischen 5 Charakteren",
            category: "Charaktere"
          },
          "59fd8282-02b7-49d9-912b-3137e5b72cf2": {
            name: "Virale Sensation",
            description: "Eine Geschichte erhält 1.000+ Aufrufe",
            category: "Soziales"
          },
          "5a867724-a8ab-4ddd-a85c-b5864a5f8387": {
            name: "Tiefgründiger Denker",
            description: "Fügen Sie 3 Charakteren eine detaillierte Hintergrundgeschichte hinzu",
            category: "Charaktere"
          },
          "66cc4e5d-2a9e-48d7-ae08-4d51993b4693": {
            name: "Geselliger Schmetterling",
            description: "Bewerten Sie 20 Geschichten",
            category: "Gemeinschaft"
          },
          "741e00ae-a32d-4495-9191-bd52d90389d2": {
            name: "Horror-Liebhaber",
            description: "Schließen Sie 20 Horrorgeschichten ab",
            category: "Genres"
          },
          "8a28897b-8993-4b11-a9c6-490703d87066": {
            name: "Serienstarter",
            description: "Veröffentlichen Sie die erste Geschichte einer mehrteiligen Serie",
            category: "Schreiben"
          },
          "98ed9a67-4eb9-4c2c-b119-ab270373346a": {
            name: "Ausgewogene Stimme",
            description: "Erzielen Sie mehr vom Benutzer bearbeitete Antworten",
            category: "Schreiben"
          },
          "99820441-a9eb-4c9e-a044-80dcf23c0dd6": {
            name: "Empfehlungsmeister",
            description: "Lade 10 Freunde ein und bring sie zum Beitreten",
            category: "Soziales"
          },
          "b19a40af-d02c-4e68-9cf2-29ed0609132b": {
            name: "Ermutiger",
            description: "Geben Sie 20+ positive Reaktionen auf Geschichten",
            category: "Gemeinschaft"
          },
          "bb25222d-2bf7-4c3d-9c69-3ee6fdc8f74c": {
            name: "Prompt-Meister",
            description: "Stellen Sie 100 einzigartige Benutzer-Prompts bereit",
            category: "Schreiben"
          },
          "d6178364-f775-483b-ac86-ebcab6f469df": {
            name: "Förderer",
            description: "Teilen Sie 5 Geschichten auf sozialen Medien",
            category: "Soziales"
          },
          "d9d3b0ad-5512-4f57-afc4-02795f488cea": {
            name: "KI-Flüsterer",
            description: "Akzeptieren Sie 500 Mal KI-generierte Antworten",
            category: "Schreiben"
          },
          "dcbda3da-f44f-468e-b650-0ba2b49de57b": {
            name: "Charakter-Künstler",
            description: "Erstelle einen Avatar für einen Charakter",
            category: "Charaktere"
          },
          "f2f6cb19-eff1-40cb-90e7-d69a13b1cee6": {
            name: "Täglicher Schriftsteller",
            description: "Erstelle an 7 aufeinanderfolgenden Tagen eine Geschichte",
            category: "Schreiben"
          },
          "f793ac53-913f-4b17-a534-08d34a768544": {
            name: "Dynamische Besetzung",
            description: "Verwenden Sie 20+ verschiedene Charaktere in Geschichten",
            category: "Charaktere"
          },
          "f949c0fc-ffab-4c4b-8cb9-050af34bfd66": {
            name: "Experimentator",
            description: "Schließen Sie in 10+ verschiedenen Genres in Geschichten",
            category: "Genres"
          }
        }
      },
      storyStats: {
        loading: "Statistiken werden geladen...",
        totalStories: "Gesamtanzahl Geschichten",
        completed: "Abgeschlossen",
        published: "Veröffentlicht",
        averageRating: "Durchschnittliche Bewertung",
        categoryRelationships: "Kategorie-Beziehungen",
        primaryCategory: "Primäre Kategorie",
        secondaryCategory: "Sekundäre Kategorie",
        selectCategory: "Kategorie auswählen",
        genre: "Genre",
        themes: "Themen",
        environment: "Umgebung",
        noCategoryData: "Keine Kategoriedaten verfügbar",
        lessFrequent: "Weniger häufig",
        moreFrequent: "Häufiger",
        usageDescription: "Zeigt, wie oft Kategorien in Ihren Geschichten zusammen verwendet werden",
        stories: "Geschichten",
        noDataAvailable: "Keine Daten verfügbar",
      },
      characterStats: {
        loading: "Charakterstatistiken werden geladen...",
        totalCharacters: "Gesamte Charaktere",
        publicCharacters: "Öffentliche Charaktere",
        averageRating: "Durchschnittliche Bewertung",
        traitRelationships: "Charaktereigenschaftsbeziehungen",
        primaryTraitType: "Primärer Eigenschaftstyp",
        secondaryTraitType: "Sekundärer Eigenschaftstyp",
        selectTraitType: "Eigenschaftstyp auswählen",
        personalityTraits: "Persönlichkeitsmerkmale",
        strengths: "Stärken",
        weaknesses: "Schwächen",
        skills: "Fähigkeiten",
        noTraitData: "Keine Daten zu Eigenschaftsbeziehungen verfügbar",
        lessFrequent: "Weniger häufig",
        moreFrequent: "Häufiger",
        usageDescription: "Zeigt, wie oft verschiedene Eigenschaften in deinen Charakteren zusammen vorkommen",
        characters: "Charaktere"
      },
      engagementStats: {
        loading: "Statistiken werden geladen...",
        totalStories: "Geschichten Gesamt",
        avgCustomization: "Durchschn. Anpassung",
        avgWordCount: "Durchschn. Wortanzahl",
        currentStreak: "Aktuelle Serie",
        days: "Tage",
        monthlyProgress: "Monatlicher Fortschritt"
      }
    },
    author: {
      title: 'Autorenprofil',
      credits: 'Geschichte-Credits',
      creditsAvailable: 'Sie haben {{count}} Credits verfügbar',
      memberSince: 'TaleCraft-Mitglied',
      loading: 'Wird geladen...',
      recentBadges: 'Neueste Abzeichen',
      noBadgesYet: 'Noch keine Abzeichen verdient',
      earnedOn: 'Verdient am {{date}}',
      more: 'mehr'
    },
    access: {
      restricted: "Zugriff eingeschränkt",
      loginRequired: "Anmeldung erforderlich",
    }
  }
};
